import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { TopNavbarStyled } from '../TopNavbarStyled';
import { rem } from 'polished';

export const TopNavbarStyledDS = styled(TopNavbarStyled)`
    background-color: ${({ theme }) => theme.colors.grey16};

    .content {
        font-size: ${rem('22px')};

        &-title {
            color: ${({ theme }) => theme.colors.black1};
        }

        &-step {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};

            &::after {
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            }
        }
    }

    .topnavbar-returnlink {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: ${rem(24)};
        color: ${({ theme }) => theme.colors.black};
        padding: 0 ${rem(24)};
        height: ${rem(48)};
        border: 1px solid ${({ theme }) => theme.colors.black};
        background: ${({ theme }) => theme.colors.white};
        line-height: ${rem(16)};
        text-transform: capitalize;

        .icon-wrapper {
            width: ${rem(40)};
        }

        svg {
            height: ${rem(30)};
            width: ${rem(20)};

            path {
                stroke: ${({ theme }) => theme.colors.black};
            }
        }

        &:not(.isDisabled) {
            :hover,
            :focus-visible {
                color: ${({ theme }) => theme.colors.primary};
                background: ${({ theme }) => theme.colors.grey4};
                border-color: ${({ theme }) => theme.colors.primary};
                svg {
                    path {
                        stroke: ${(p) => p.theme.colors.primary};
                    }
                }
            }
        }

        &:hover,
        &:focus-visible {
        }
    }

    .content-title {
        font-size: ${({ theme }) => theme.fontSizes.h5};

        @media (min-width: ${breakpoints.sm}px) {
            font-size: ${rem(32)};
        }
    }
`;
